
import { ConfigBucketStorage } from "@/feature-flags/flags-config-bucket-storage";
import { Vue } from "vue-class-component";
export default class BannerProductType extends Vue {
  bannerFileLink = `${ConfigBucketStorage.config_bucket_prd_genesis.getValue()}/banner-upselling-2.webp`;
}
